import { definePreset, palette } from '@primeng/themes';
import Aura from '@primeng/themes/aura';
import { providePrimeNG } from 'primeng/config';

export type UshThemeOptions = {
  darkModeSelector?: string | boolean;
  prefix?: string;
  cssLayer?: boolean;
  [key: string]: unknown;
};

export const ushThemePreset = definePreset(Aura, {
  semantic: {
    primary: palette('{transparent}')
  },
  components: {
    button: {
      icon: {
        only: {
          width: '2.357rem'
        }
      }
    }
  }
});

export const provideUshTheme = (options: UshThemeOptions = {}) =>
  providePrimeNG({
    theme: {
      preset: ushThemePreset,
      options: {
        darkModeSelector: false,
        ...options
      }
    }
  });
